import React from 'react';
import styles from './GoogleMap.module.scss';
import {config} from 'data/utils/constants';

interface IGoogleMapProps {
  address: string;
}

const GoogleMap = (props: IGoogleMapProps) => {
  if (props.address) {
    const formattedAddress = props.address.split(",").map(a => a.trim()).filter(a => !(/^\d+$/.test(a))).join(",");
    return (
      <div className={styles.GoogleMap}>
        <iframe
          src={`https://www.google.com/maps/embed/v1/search?key=${config.google.maps}&q=${formattedAddress}`}
          height="610px"
          width="100%"
        />
      </div>
    )
  }
  return null;
};
GoogleMap.defaultProps = {};
export default React.memo(GoogleMap);
